var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
var GET_CURRENT_USER = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getCurrenctUser {\n    currentUser @client {\n      id\n      username\n    }\n  }\n"], ["\n  query getCurrenctUser {\n    currentUser @client {\n      id\n      username\n    }\n  }\n"])));
export default GET_CURRENT_USER;
var templateObject_1;
